import * as R from "ramda";
import { ICoursePublication } from "../../types";

export interface IPatchPayload {
  baseVersionId: number;
  clientPatches: Array<IClientPatch<IPatchAction>>;
}

export interface IPatchResponse {
  baseVersionId: number;
  numClientPatches: number;
}

export interface IServerPatchResponse extends IPatchResponse {
  serverPatches: Array<IClientPatch<IPatchAction>>;
}

export interface IClientPatch<T extends IPatchAction> {
  createdAt: string;
  createdBy: string;
  patch: IPatch<T>;
  undoVersionId: number | null;
  versionId: number;
}

export interface IPatch<ActionType extends IPatchAction> {
  action: ActionType;
  position: string;
}

export enum PatchType {
  add = "add",
  del = "del",
  ins = "ins",
  move = "move",
  subst = "subst",
}

export type IPatchAction =
  | IPatchSubstAction<any>
  | IPatchAddAction<any>
  | IPatchMoveAction
  | IPatchDeleteAction<any>
  | IPatchInsertAction<any>;

export interface IPatchDeleteAction<T> {
  elem: T;
  type: PatchType.del;
}

export interface IPatchInsertAction<T> {
  elem: T;
  type: PatchType.ins;
}

export interface IPatchMoveAction {
  from: number;
  to: number;
  type: PatchType.move;
}

export interface IPatchAddAction<T> {
  at: number;
  item: T;
  type: PatchType.add;
}

export interface IPatchSubstAction<T> {
  type: PatchType.subst;
  x: T;
  y: T;
}

export type CourseChanges = Array<IClientPatch<IPatchAction>>;

export function isPublicationPatch(
  clientPatch: IClientPatch<IPatchAction>
): clientPatch is IClientPatch<IPatchAddAction<ICoursePublication> | IPatchSubstAction<boolean>> {
  const {
    patch: { action, position },
  } = clientPatch;
  const pos = R.slice(0, 12, position);
  return (
    pos === "publications" &&
    ((action.type === PatchType.add &&
      R.type(action.at) === "Number" &&
      action.item &&
      R.type(action.item.revision) === "Number" &&
      R.type(action.item.id) === "Number" &&
      action.item.notes === "") ||
      (action.type === PatchType.subst && R.type(action.x) === "Boolean" && R.type(action.y) === "Boolean"))
  );
}
